// extracted by mini-css-extract-plugin
export default {"wrapper":"fzwOtYB4","right":"XhujZS00","title":"AGaMqEZN","discussionLink":"NUjOrgw3","discussionTitle":"TI2vqaNx"};